import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
/* eslint-disable vue/component-api-style */
// Needs to be with the option API to work with the Algolia Mixin
import { createWidgetMixin } from 'vue-instantsearch/vue2/es';
import { connectSearchBox } from 'instantsearch.js/es/connectors/index.js';
import { autocomplete } from '@algolia/autocomplete-js';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { useAlgoliaSearch } from '~/composables/_next/useAlgoliaSearch';
export default {
  mixins: [createWidgetMixin({
    connector: connectSearchBox
  })],
  props: {
    initialQuery: {
      type: String,
      default: ''
    }
  },
  watch: {
    initialQuery: function initialQuery(val) {
      if (val && this.autocompleteInstance) {
        this.autocompleteInstance.setQuery(val);
      }
    }
  },
  mounted: function mounted() {
    var vm = this;
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n,
      app = _useNuxt2App.app;
    var instantSearchInstance = vm.instantSearchInstance;
    var virtualSearchBox = connectSearchBox(function () {
      return null;
    });
    var _useAlgoliaSearch = useAlgoliaSearch(),
      searchClient = _useAlgoliaSearch.searchClient,
      indexProduct = _useAlgoliaSearch.indexProduct,
      indexRecipe = _useAlgoliaSearch.indexRecipe,
      indexAdvice = _useAlgoliaSearch.indexAdvice;
    var indexNames = [indexProduct, indexRecipe, indexAdvice];
    var router = useRouter();
    indexNames.forEach(function (indexName) {
      instantSearchInstance.addWidgets([virtualSearchBox({
        indexId: indexName
      })]);
    });
    function setAllUiStates(_ref) {
      var query = _ref.query;
      instantSearchInstance.setUiState(function (uiState) {
        var updates = {};
        for (var _i = 0, _indexNames = indexNames; _i < _indexNames.length; _i++) {
          var index = _indexNames[_i];
          updates[index] = _objectSpread(_objectSpread({}, uiState[index] || {}), {}, {
            query: query,
            page: 1
          });
        }
        return _objectSpread(_objectSpread({}, uiState), updates);
      });
    }
    vm.autocompleteInstance = autocomplete({
      container: vm.$refs.autocompleteContainer,
      placeholder: i18n.t('search.inputPlaceholder'),
      detachedMediaQuery: 'none',
      initialState: {
        query: vm.initialQuery
      },
      onSubmit: function onSubmit(_ref2) {
        var state = _ref2.state;
        setAllUiStates({
          query: state.query
        });
        if (state.query) {
          var _useDynamicYield = useDynamicYield(),
            trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent;
          trackDynamicYieldEvent({
            name: 'Keyword Search',
            properties: {
              dyType: 'keyword-search-v1',
              keywords: state.query
            }
          });
          router.push(app.localePath({
            name: 'search-term',
            params: {
              term: state.query
            }
          }));
          vm.$emit('close');
        }
      },
      onReset: function onReset() {
        setAllUiStates({
          query: ''
        });
        vm.$emit('typing', '');
      },
      onStateChange: function onStateChange(_ref3) {
        var _state$query;
        var state = _ref3.state;
        vm.$emit('open');
        vm.$emit('typing', state.query);
        setAllUiStates({
          query: state.query
        });
        if ((_state$query = state.query) !== null && _state$query !== void 0 && _state$query.trim()) {
          searchClient.initIndex(indexProduct).search(state.query).then(function (response) {
            var _response$renderingCo, _response$renderingCo2;
            var redirectUrl = response === null || response === void 0 ? void 0 : (_response$renderingCo = response.renderingContent) === null || _response$renderingCo === void 0 ? void 0 : (_response$renderingCo2 = _response$renderingCo.redirect) === null || _response$renderingCo2 === void 0 ? void 0 : _response$renderingCo2.url;
            if (redirectUrl) {
              router.push({
                path: redirectUrl
              });
              vm.$emit('close');
            }
          });
        }
      },
      render: function render() {}
    });
  },
  beforeDestroy: function beforeDestroy() {
    var _this$autocompleteIns;
    (_this$autocompleteIns = this.autocompleteInstance) === null || _this$autocompleteIns === void 0 ? void 0 : _this$autocompleteIns.destroy();
  }
};